document.addEventListener('click', function (e) {
  const button = e.target.closest('.fwrd-what-and-how [data-video-button]');
  if (!button) return;

  const section = button.closest('.fwrd-what-and-how');
  if (!section) return;

  const video = section.querySelector('video');
  if (!video) return;

  const cover = section.querySelector('.fwrd-what-and-how__cover-image-wrapper');
  const playIcon = button.querySelector('svg');
  const pauseIcon = button.querySelector('.fwrd-what-and-how__icon-pause');

  if (video.paused) {
    video.play();
    if (cover) cover.style.display = 'none';
    playIcon.style.display = 'none';
    pauseIcon.style.display = 'flex';
    button.setAttribute('aria-label', 'Pause video');
  } else {
    video.pause();
    if (cover) cover.style.display = 'block';
    playIcon.style.display = 'block';
    pauseIcon.style.display = 'none';
    button.setAttribute('aria-label', 'Play video');
  }
});
